<template>
    <div class='scene' id="scene">

    </div>
</template>

<script>

import * as THREE from 'three';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader';
import Stats from "three/examples/jsm/libs/stats.module"


export default {
    name: "Playground",


    methods:{
        startThreeScene() {
            const stats = Stats()
            const domElement = document.getElementById("scene")
            domElement.appendChild(stats.dom)

            const scene = new THREE.Scene()
            scene.background = new THREE.Color( 0xeeeeee );

            const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
            const renderer = new THREE.WebGLRenderer()
            renderer.setSize(window.innerWidth, window.innerHeight)

            const light = new THREE.DirectionalLight( 0xFFFFFF, 1 );
            const helper = new THREE.DirectionalLightHelper( light, 5, 0xcc40404 );
            light.position.y = 2
            light.target = (0, .3, 0)
            scene(light.target)
            scene.add(helper)
            renderer.physicallyCorrectLights = true;
            renderer.gammaOutput = true
            domElement.appendChild(renderer.domElement)

            camera.position.z = 2



            const controls = new OrbitControls(camera, renderer.domElement)
            controls.update()

            // Get the GLTF Loader:


            const gltfLoader = new GLTFLoader()

            


            // Set up DRACOLoader 

            const dracoLoader = new DRACOLoader()
            dracoLoader.setDecoderPath( '/examples/js/libs/draco/' )
            gltfLoader.setDRACOLoader( dracoLoader )

            gltfLoader.load(
                'https://berkuralcan.github.io/3dConfTests/sofa-fabric/sf1.gltf',  
                function (gltf) {
                    scene.add(gltf.scene)
                }
            )

            scene.add( light );

            function animate() {
                requestAnimationFrame(animate)
                controls.update()
                renderer.render(scene, camera)
                stats.update()
            }

           animate()
        }
    },

    mounted(){
        this.startThreeScene()
    }
}


</script>

<style lang="scss" scoped>
    header.aar-header{
        display: none !important;
    }
</style>